module.exports = __webpack_public_path__ + "static/media/userNew.b6730c4f.jpg";